/**
 * Servicio para gestión de módulos del sistema
 * Usado para construir el menú dinámico y administración de módulos
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Obtiene la estructura de módulos para el menú del usuario autenticado
 * Incluye jerarquía de módulos padres e hijos
 * @returns {Promise} Estructura jerárquica de módulos
 */
export const getUserMenu = async () => {
  const response = await axios.get(`${API_URL}/modules/menu`);
  return response.data;
};

/**
 * Obtiene todos los módulos del sistema (para administración de permisos)
 * @returns {Promise} Lista de todos los módulos
 */
export const getAllModules = async () => {
  const response = await axios.get(`${API_URL}/modules`);
  return response.data;
};

/**
 * Obtiene todos los módulos en estructura de árbol jerárquico
 * @returns {Promise} Árbol de módulos
 */
export const getModulesTree = async () => {
  const response = await axios.get(`${API_URL}/modules/tree`);
  return response.data;
};

/**
 * Obtiene un módulo específico por ID
 * @param {number} id - ID del módulo
 * @returns {Promise} Datos del módulo
 */
export const getModuleById = async (id) => {
  const response = await axios.get(`${API_URL}/modules/${id}`);
  return response.data;
};

/**
 * Crea un nuevo módulo
 * @param {object} moduleData - Datos del módulo
 * @returns {Promise} Módulo creado
 */
export const createModule = async (moduleData) => {
  const response = await axios.post(`${API_URL}/modules`, moduleData);
  return response.data;
};

/**
 * Actualiza un módulo existente
 * @param {number} id - ID del módulo
 * @param {object} moduleData - Datos actualizados
 * @returns {Promise} Módulo actualizado
 */
export const updateModule = async (id, moduleData) => {
  const response = await axios.put(`${API_URL}/modules/${id}`, moduleData);
  return response.data;
};

/**
 * Desactiva un módulo
 * @param {number} id - ID del módulo
 * @returns {Promise} Resultado de la operación
 */
export const deleteModule = async (id) => {
  const response = await axios.delete(`${API_URL}/modules/${id}`);
  return response.data;
};

/**
 * Actualiza el orden de múltiples módulos
 * @param {array} modules - Array de { id, sortOrder }
 * @returns {Promise} Resultado de la operación
 */
export const reorderModules = async (modules) => {
  const response = await axios.put(`${API_URL}/modules/reorder`, { modules });
  return response.data;
};

export default {
  getUserMenu,
  getAllModules,
  getModulesTree,
  getModuleById,
  createModule,
  updateModule,
  deleteModule,
  reorderModules
};
